export default __webpack_public_path__ + "static/media/QLD_FRONT.18ae3644.png";